<template>
  <div class="row footer">
    <div class="col-md-4 col-sm-12">
      <div class="logo_gov_image">
        <a href="https://www.gov.co/home/"
          ><img
            src="https://www.minagricultura.gov.co/_catalogs/masterpage/imagenes/logo_footer.png"
            alt="logo_gobierno"
        /></a>
      </div>
      <div class="logo_colombia">
        <a href="https://www.colombia.co/"
          ><img
            src="https://www.minagricultura.gov.co/_catalogs/masterpage/imagenes/logo_co_footer.png"
            alt="logo_colombia"
        /></a>
      </div>
    </div>
    <div class="col-md-4 col-sm-12">
      <div class="flex">
        <div class="footer_text">
          <p class="footer_text_first">
            Ministerio de Agricultura y Desarrollo Rural
          </p>
        </div>
        <div class="footer_text">
          <p class="footer_text_first">Correo Electrónico Institucional</p>
          <p class="footer_text_last">{{ email }}</p>
        </div>
        <div class="footer_text">
          <p class="footer_text_first">Línea de atención al ciudadano</p>
          <p class="footer_text_first">Nacional Gratuita</p>
          <p class="footer_text_last">{{ phone }}</p>
        </div>
      </div>
    </div>
    <div class="col-md-4 col-sm-12">
      <div class="footer_text">
        <p class="footer_text_first">Horario de atención</p>
        <p class="footer_text_first">{{ schedule }}</p>
      </div>
    </div>
    <div class="col-md-12 col-sm-12">
      <div class="row footer_of_footer">
        <div class="col-md-12 col-sm-12">
          <a @click="responsabilidad()" style="cursor: pointer;">
            Responsabilidad de datos
          </a>
          <span class="separator">|</span>
          <a @click="privacidad()" style="cursor: pointer;">
            Privacidad de información
          </a>
          <span class="separator">|</span>
          <a href="PNUD_MANUSR_SPUB_V3.0.pdf" style="cursor: pointer;">
            Manual de Usuario
          </a>
        </div>
      </div>
    </div>
    <Responsabilidad />
    <Privacidad />
    <br /><br />
  </div>
</template>

<script>
import Responsabilidad from "../Responsabilidad";
import Privacidad from "../Privacidad";
import axios from "axios";
import config from "../../../helpers/config";

export default {
  data() {
    return {
      phone: "",
      email: "",
      schedule: "",
    };
  },
  methods: {
    responsabilidad() {
      this.$modal.show("responsabilidad");
    },
    privacidad() {
      this.$modal.show("privacidad");
    },
  },
  components: {
    Responsabilidad,
    Privacidad,
  },
  created() {
    const that = this;
    axios
      .get(`${config.urlApi}/footerData`, {})
      .then((response) => {
        const { email, schedule, phone } = response.data[0];
        this.email = email;
        this.schedule = schedule;
        this.phone = phone;

        this.$store.state.footer.email = email;
        this.$store.state.footer.schedule = schedule;
        this.$store.state.footer.phone = phone;
      })
      .catch(function(error) {
        ////console.log(error)
      });
  },
};
</script>

<style>
.footer {
  margin: 0 !important;
  background-color: #3366cc;
  position: relative;
  bottom: 0;
  width: 100%;
  min-height: 120px;
  color: white;
  text-align: center;
  margin-top: 80px;
}
.footer > .col-md-4 {
  margin-top: 20px;
}
.separator {
  color: #fff;
  font-size: 20px;
}
.footer_text > p {
  padding: 0px !important;
  margin: 0px !important;
}
.footer_text_first {
  font-weight: 100;
}
.footer_text_last {
  font-weight: bolder;
}
.footer_of_footer {
  margin-top: 10px;
  font-size: 12px;
}
.footer_of_footer > .col-md-12 > a,
.footer_of_footer > .col-sm-12 > a {
  color: #fff !important;
}
.logo_gov_image {
  margin-top: 10px;
  margin-bottom: 20px;
}
.logo_gov_image img {
  height: 30px;
}
.row.footer > div:nth-child(1) {
  border-right: 1px solid #ffffff;
}
.row.footer > div:nth-child(2) {
  border-right: 1px solid #ffffff;
}

@media (max-width: 768px) {
  .row.footer {
    flex-direction: column;
    align-items: center;
  }
  .row.footer > div {
    max-width: 80%;
    padding-bottom: 10px;
  }
  .row.footer > div:nth-child(1) {
    border-bottom: 1px solid #ffffff;
    border-right: 0px;
  }
  .row.footer > div:nth-child(2) {
    border-bottom: 1px solid #ffffff;
    border-right: 0px;
  }
}
</style>
